import { keepPreviousData, useQuery, type UseQueryResult } from '@tanstack/react-query';

import { api, ApiError } from '@/lib/api';
import { leaveIfSignedOut } from '@/lib/platform/accounts';
import { readQueryScope, tenantKey } from '@/lib/query/scope';

export function useTenantQuery<T>(
  parts: readonly unknown[],
  path: string,
  parse: (payload: unknown) => T,
  enabled = true,
): UseQueryResult<T> {
  const scope = readQueryScope();

  return useQuery({
    queryKey: tenantKey(scope, parts),
    enabled,
    placeholderData: keepPreviousData,
    queryFn: async ({ signal }) => {
      try {
        return parse(await api<unknown>(path, { signal }));
      } catch (error: unknown) {
        if (error instanceof ApiError) leaveIfSignedOut(error);
        throw error;
      }
    },
  });
}
